<template>
  <Card>
    <template #title>{{ $t('features.sign_in.sign_in') }}</template>
    <template #content>
      <form @submit.prevent="onSubmit">
        <InputText
          v-model.trim="email"
          :placeholder="$t('global.email')"
          class="w-full my-1"
        />

        <Password
          v-model.trim="password"
          :placeholder="$t('global.password')"
          :feedback="false"
          toggle-mask
          inputClass="w-full"
          style="width: 100%"
          class="my-1"
        />

        <Divider />

        <Button
          type="submit"
          variant="primary"
          :label="$t('features.sign_in.login')"
          :loading="loading"
          class="w-full my-1"
        />
      </form>

      <Message v-if="credentialsIncorrect" severity="error" :closable="false">
        {{ $t('features.sign_in.credentials_incorrect') }}
      </Message>

      <div v-if="errorMessages">
        <Message
          v-for="message in errorMessages"
          severity="error"
          :closable="false"
        >
          {{ message }}
        </Message>
      </div>

      <a href="/forgot-password">
        {{ $t('features.sign_in.password_forgot') }}?
      </a>
    </template>
  </Card>
  <UserTips/>
</template>

<script lang="ts">
import CompanyApi from '@/data/companies/CompanyApi.ts';
import SignInService from '@/domain/authentication/services/SignInService.js';
import UserTips from '@/presentation/components/users/UserTips.vue';

export default {
  name: 'Authentication',
  components: { UserTips },
  data() {
    return {
      email: '',
      password: '',
      loading: false,
      credentialsIncorrect: false,
      errorMessages: null as Array<string>,
    };
  },
  methods: {
    onSubmit() {
      this.loading = true;
      this.credentialsIncorrect = false;
      this.errorMessages = null;

      const signInService = new SignInService();
      const companyApi = new CompanyApi();

      signInService
        .signIn(this.email, this.password)
        .then((isAuthenticated) => {
          return companyApi
            .allOfMe({}, ['parents'])
            .then((response) => {
              this.loading = false;
              this.$emit('authenticated', isAuthenticated, response.data);
            })
            .catch((error) => {
              this.loading = false;
              this.errorMessages = error.messageBag.all();
            });
        })
        .catch((result) => {
          const error = result.response.data.error;
          this.credentialsIncorrect = true;

          if (error.code !== 3000) {
            this.credentialsIncorrect = true;
          } else {
            this.errorMessages = error.messages;
          }
          this.loading = false;
        });
    },
  },
};
</script>
